import * as actionTypes from '../actionTypes';

export function handle400(request, response) {
  return new Promise((resolve, reject) => {
    response.json()
      .then((json) => {
        resolve({
          type: actionTypes.RESPONSE_BAD_REQUEST,
          request,
          response,
          errors: json.errors || {},
        });
      })
      .catch((error) => {
        resolve({
          type: actionTypes.RESPONSE_BAD_REQUEST,
          request,
          response,
          errors: {unknown: 'Bad request'},
        });
      });
  });
}

export function handle403(request, response) {
  return new Promise((resolve, reject) => {
    resolve({
      type: actionTypes.RESPONSE_NOT_ALLOWED,
      request,
      response,
    });
  });
}

export function handle404(request, response) {
  return new Promise((resolve, reject) => {
    resolve({
      type: actionTypes.RESPONSE_NOT_FOUND,
      request,
      response,
    });
  });
}



// WEBPACK FOOTER //
// ./app/javascript/requests/responseHandlers/4xx.js